import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../styles/AnimatedPage.css';

const AnimatedPage = ({ children }) => {
  const [isAnimationFinished, setIsAnimationFinished] = useState(false);

  const cubeVariants = {
    hidden: { scaleY: 1, opacity: 1 },
    visible: {
      scaleY: 0,
      opacity: 0,
      transition: { duration: 1.1, ease: 'easeInOut' } // tu timing original
    }
  };

  return (
    <div className="page-container">
      {/* Mantiene el efecto: velo + cubo, pero no bloquea ni retrasa el contenido */}
      {!isAnimationFinished && (
        <div className="cube-container">
          <motion.div
            className="cube top-left"
            initial="hidden"
            animate="visible"
            variants={cubeVariants}
            onAnimationComplete={() => setIsAnimationFinished(true)} // desmonta overlay
          />
        </div>
      )}

      {/* El contenido renderiza y está visible desde el primer paint */}
      <div className="animated-page">
        {children}
      </div>
    </div>
  );
};

export default AnimatedPage;
